import { useLocalSearchParams } from "expo-router";
import { useEffect, useState } from "react";
import { View, ScrollView, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { ThemedText } from "@/components/ThemedText";

export default function DocsPage() {
  const { slug } = useLocalSearchParams<{ slug: string[] }>();
  const { colors } = useTheme();
  const [content, setContent] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const path = Array.isArray(slug) ? slug.join("/") : slug || "index";

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        // Attempt to load markdown from assets/docs/<slug>.md
        // On web, assets in the assets/ dir are served statically by metro/webpack
        const res = await fetch(`/assets/docs/${path}.md`);
        if (!res.ok) {
          if (!cancelled) setError(`Not found: ${path}`);
          return;
        }
        const text = await res.text();
        if (!cancelled) setContent(text);
      } catch (e: any) {
        if (!cancelled) setError(e.message ?? "Failed to load document");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [path]);

  return (
    <ScrollView
      style={[styles.container, { backgroundColor: colors.background }]}
      contentContainerStyle={styles.content}
    >
      {error && (
        <View style={styles.errorContainer}>
          <ThemedText style={{ color: colors.textSecondary }}>{error}</ThemedText>
        </View>
      )}
      {content && <ThemedText style={styles.body}>{content}</ThemedText>}
      {!content && !error && <ThemedText style={{ color: colors.textSecondary }}>Loading...</ThemedText>}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    padding: 24,
    maxWidth: 800,
  },
  errorContainer: {
    padding: 16,
  },
  body: {
    fontSize: 15,
    lineHeight: 24,
  },
});
